import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { logger } from "@/lib/logger";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const bootstrap = async () => {
      const token = localStorage.getItem("bp_token");
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (err) {
        logger.warn("Auth bootstrap failed, clearing token:", err?.response?.status || err?.message);
        localStorage.removeItem("bp_token");
      } finally {
        setLoading(false);
      }
    };
    bootstrap();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("bp_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name, referral_code) => {
    const body = { email, password, name };
    if (referral_code) body.referral_code = referral_code;
    const { data } = await api.post("/auth/register", body);
    localStorage.setItem("bp_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      logger.warn("Server logout failed (proceeding to clear local session):", err?.message);
    }
    localStorage.removeItem("bp_token");
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (err) {
      logger.warn("refreshUser failed:", err?.response?.status || err?.message);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
